import './DateButton.sass';

import { FC, useState } from 'react';
import formatDate from 'date-fns/format';
import { fromUnixTime } from 'date-fns';

import { Button } from '$uikit';
import { IcCalendar28 } from '$assets';
import { useTranslator } from '$hooks';

import { DateRangePreset, PRESET_DEFAULTS, PRESET_KEYS } from './DateRangeSection';
import { DateRangeSheet } from './DateRangeSheet';

export interface DateButtonProps {
  preset: DateRangePreset;
  startDay: number;
  endDay: number;
  onChange: (preset: DateRangePreset, startDay: number, endDay: number) => void;
}

const formatDay = (unix: number) => formatDate(fromUnixTime(unix), 'd MMM');

export const DateButton: FC<DateButtonProps> = ({
  preset,
  startDay,
  endDay,
  onChange,
}) => {
  const t = useTranslator();
  const [open, setOpen] = useState(false);

  const triggerLabel =
    preset === 'custom'
      ? `${formatDay(startDay)} — ${formatDay(endDay)}`
      : t(PRESET_KEYS[preset], { defaultValue: PRESET_DEFAULTS[preset] });

  return (
    <>
      <Button
        mode="secondary"
        size="extra-small"
        icon={<IcCalendar28 />}
        onClick={() => setOpen(true)}
      >
        {triggerLabel}
      </Button>

      {open && (
        <DateRangeSheet
          preset={preset}
          startDay={startDay}
          endDay={endDay}
          onChange={onChange}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};
